module.exports = __webpack_public_path__ + "static/img/v7.a0ff8c2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newmember/v7.jpg
// module id = HYe3
// module chunks = 1